import * as React from 'react';
import * as main from '../../main.module.scss';
import * as gifts from './style.module.scss';
export const Gifts = ({ widgetFree }) => {
  return (
    <section className={gifts.gifts}>
      <div className="container">
        <h2 className={main.title}>5 подарков для участников марафона</h2>
        <p className={main.subtitle}>гарантированно сдвинут вас с мёртвой точки</p>
        <ul>
          <li>
            <a href="#giftsForm">
              <img
                src="https://fs.advance.ru/landing-pages/marathon/marafon_motivacii_i_obuchenija_detej_2025/5gift-globe.png"
                alt=""
              />
              <h3>
                Онлайн-курс
                <br />
                «Глобус на пальце»
              </h3>
              <p>Курс для тех, кто хочет знать все страны в мире и их расположение на карте</p>
            </a>
          </li>
          <li>
            <a href="#giftsForm">
              <img
                src="https://fs.advance.ru/landing-pages/marathon/marafon_motivacii_i_obuchenija_detej_2025/5gift-5neuro.png"
                alt=""
              />
              <h3>
                Мини-курс
                <br />
                «5 нейроупражнений»
              </h3>
              <p>Разгони свой мозг и забудь об усталости всего за 5 дней с нашими нейротренировками</p>
            </a>
          </li>
          <li>
            <a href="#giftsForm">
              <img
                src="https://fs.advance.ru/landing-pages/marathon/marafon_motivacii_i_obuchenija_detej_2025/5gift-objects.png"
                alt=""
              />
              <h3>«Следи за объектом»</h3>
              <p>Онлайн-игра для развития внимания и памяти</p>
            </a>
          </li>
          <li>
            <a href="#giftsForm">
              <img
                src="https://fs.advance.ru/landing-pages/marathon/marafon_motivacii_i_obuchenija_detej_2025/5gift-100slov.png"
                alt=""
              />
              <h3>
                Онлайн-курс
                <br />
                «100 английских слов для путешествий»
              </h3>
              <p>Курс для тех, кто хочет быстро запоминать иностранные слова</p>
            </a>
          </li>
          <li>
            <a href="#giftsForm">
              <img
                src="https://fs.advance.ru/landing-pages/marathon/marafon_motivacii_i_obuchenija_detej_2025/5gift-planning.png"
                alt=""
              />
              <h3>Экспресс-курс по планированию</h3>
              <p>Больше 10 методов планирования</p>
            </a>
          </li>
        </ul>
        <div className={gifts.reg} id={'giftsForm'}>
          <h3>Заполните поля и мы отправим доступ на почту</h3>
          {widgetFree}
        </div>
      </div>
    </section>
  );
};
